<template lang="pug">
.pa-4
  component(
    :is="answer_blocks[answer_block_data.type]",
    :answer_values="answer_block_data.values",
    v-model="input"
  ) 
</template>

<script>
import Radio from "./Blocks/Radio";
import Input from "./Blocks/Input";
import Autocomplete from "./Blocks/Autocomplete";
import Select from "./Blocks/Select";
import Datepicker from "./Blocks/Datepicker";
import JobTitles from "./Blocks/JobTitles";
import Checkbox from "./Blocks/Checkbox";

export default {
  props: ["answer_block_data", "value"],

  data() {
    return {
      answer_blocks: {
        radio: Radio,
        input: Input,
        autocomplete: Autocomplete,
        select: Select,
        date: Datepicker,
        "job-titles": JobTitles,
        checkbox: Checkbox,
      },
    };
  },

  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>